/// <amd-module name="Build/Admin/Pool/Stores/SelectionStore" />
import { Store } from "VSS/Reflux/Store";

import { ElasticPool, TaskAgentQueue, TaskAgentPool } from "DistributedTask/Client/Contracts/TaskAgent";

import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

import { VirtualMachineScaleSet } from "Build/Admin/Common/Client/Contracts/DistributedTask/Azure";
import { PoolHubViewKeys } from "Build/Admin/Common/Constants";

export interface ISelectionState {
    selectedAgentPool: TaskAgentPool | undefined;
    selectedAgentQueue: TaskAgentQueue | undefined;
    selectedElasticPool: ElasticPool | undefined;
    selectedServiceEndpoint: ServiceEndpoint | undefined;
    selectedVirtualMachineScaleSet: VirtualMachineScaleSet | undefined;
    selectedTabId: string;
}

export class SelectionStore extends Store {
    public state: ISelectionState = {
        selectedAgentPool: undefined,
        selectedAgentQueue: undefined,
        selectedElasticPool: undefined,
        selectedServiceEndpoint: undefined,
        selectedVirtualMachineScaleSet: undefined,
        selectedTabId: PoolHubViewKeys.Jobs
    };

    constructor() {
        super("SelectionStoreChanged");
    }

    public updateSelectedAgentPool = (newAgentPool: TaskAgentPool | undefined): void => {
        this.state = {
            ...this.state,
            selectedAgentPool: newAgentPool
        };
        this.emitChanged();
    }

    public updateSelectedAgentQueue = (newAgentQueue: TaskAgentQueue | undefined): void => {
        this.state = {
            ...this.state,
            selectedAgentQueue: newAgentQueue
        };
        this.emitChanged();
    }

    public updateSelectedElasticPool = (newElasticPool: ElasticPool | undefined): void => {
        this.state = {
            ...this.state,
            selectedElasticPool: newElasticPool
        };
        this.emitChanged();
    }

    public updateSelectedServiceEndpoint = (newServiceEndpoint: ServiceEndpoint | undefined): void => {
        this.state = {
            ...this.state,
            selectedServiceEndpoint: newServiceEndpoint
        };
        this.emitChanged();
    }

    public updateSelectedVirtualMachineScaleSet = (newVirtualMachineScaleSetl: VirtualMachineScaleSet | undefined): void => {
        this.state = {
            ...this.state,
            selectedVirtualMachineScaleSet: newVirtualMachineScaleSetl
        };
        this.emitChanged();
    }

    public updateSelectedTab = (newTabId: string): void => {
        this.state = {
            ...this.state,
            selectedTabId: newTabId
        };
        this.emitChanged();
    }
}
